module.exports = __webpack_public_path__ + "static/media/call.44118324.svg";